import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Feature } from "../../interfaces/feature";

@Injectable()
export class FeatureService {
  env: any = environment;

  constructor(private http: HttpClient) {}

  getFeaturesByProjectId(projectId): Promise<Feature[]> {
    return new Promise((resolve, reject) => {
      const params = new HttpParams().set("projectId", projectId);
      this.http
        .get<any>(this.env.managirUrl + "/features", {
          params: params,
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.FeatureResponse.features);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  async moveToSprint(featureId: any, sprintId: any): Promise<boolean> {
    try {
      await this.http
        .post<any>(
          `${this.env.managirUrl}/features/${featureId}/moveToSprint/${sprintId}`,
          null
        )
        .toPromise();
      return true;
    } catch (ex) {
      return false;
    }
  }

  createFeature(feature): Promise<Feature> {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(this.env.managirUrl + "/features", feature, {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.FeatureResponse.features[0]);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  saveFeature(feature) {
    return new Promise((resolve, reject) => {
      this.http
        .put<any>(this.env.managirUrl + "/features/" + feature._id, feature, {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.FeatureResponse.features[0]);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  deleteFeatureById(featureId) {
    return new Promise((resolve, reject) => {
      this.http
        .delete<any>(this.env.managirUrl + "/features/" + featureId, {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.message);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  deleteItemsByEpicId(epicId) {
    return new Promise((resolve, reject) => {
      const params = new HttpParams().set("epicId", epicId);
      this.http
        .delete<any>(this.env.managirUrl + "/features", {
          params: params,
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/feature/feature.service.ts